import { RouteType } from "types/RouteType";
import dispatchRoute from "./Dispatch/dispatch.Route";
import dispatchDashboardRoute from "./Dashboard/dispatchDashboard.Route";
import loadListRoute from "./LoadList/loadList.Route";
import trailerInventoryRoute from "./TrailerInventory/trailerInventory.Route";

const dispatchRoutesList: RouteType[] = [
    dispatchDashboardRoute,
    dispatchRoute,
    loadListRoute,
    ...trailerInventoryRoute,
];

export default dispatchRoutesList;
